import { render, staticRenderFns } from "./ChartFaturamentoTotal.vue?vue&type=template&id=f2c1bc4e"
import script from "./ChartFaturamentoTotal.vue?vue&type=script&lang=js"
export * from "./ChartFaturamentoTotal.vue?vue&type=script&lang=js"
import style0 from "./ChartFaturamentoTotal.vue?vue&type=style&index=0&id=f2c1bc4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports